import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import SwalAlertComp from "../SwalAlert";
import {
    getAllSourceMapping,
    sendAllSourceUpdate,
} from "../../helpers/Sources/createSource";
import MappingEmptyState from "../atoms/MappingEmptyState";

const AllSelectSourceEditMappings = ({ ftpMappingId, setShowFtpMapping }) => {
    const language = useSelector((state) => state.languagesState.languages);
    const [loading, setLoading] = useState(true);
    const [sourceMappingData, setSourceMappingData] = useState([]);
    const [hasNoMapping, setHasNoMapping] = useState(false);
    const [mapping, setMapping] = useState({
        lead_id: "",
        lead_status: "",
        lead_date: "",
    });

    useEffect(() => {
        const getFtpData = async () => {
            let response = await getAllSourceMapping(ftpMappingId);
            if (response.status) {
                setLoading(false);
                setSourceMappingData(response?.data);
                if (!response?.data?.length) {
                    setHasNoMapping(true);
                }
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response?.message ?? "",
                    icon: "error",
                });
                setLoading(false);
            }
        };
        getFtpData();
    }, []);

    useEffect(() => {
        if (sourceMappingData && sourceMappingData.length > 0) {
            const options = sourceMappingData.map((item) => ({
                value: item.api_value,
                label: item.display_value,
            }));

            const selectedLeadId = sourceMappingData.find(
                (item) => item.key === "lead_id",
            );

            const selectedLeadStatus = sourceMappingData.find(
                (item) => item.key === "lead_status",
            );

            const selectedLeadDate = sourceMappingData.find(
                (item) => item.key === "lead_date",
            );

            setMapping((prevMapping) => ({
                ...prevMapping,
                lead_id: selectedLeadId
                    ? selectedLeadId.api_value
                    : options[0]?.value,
                lead_status: selectedLeadStatus
                    ? selectedLeadStatus.api_value
                    : options[0]?.value,
                lead_date: selectedLeadDate
                    ? selectedLeadDate.api_value
                    : options[0]?.value,
            }));
        }
    }, [sourceMappingData]);

    const handleSourceFieldChange = (selectedOption, field) => {
        setMapping((prevMapping) => ({
            ...prevMapping,
            [field]: selectedOption,
        }));
    };

    const closeModal = () => {
        setShowFtpMapping(false);
        setMapping({
            lead_id: "",
            lead_status: "",
            lead_date: "",
        });
    };

    const sendMappingData = async () => {
        let data = {
            mappings: {
                lead_id: mapping?.lead_id || "none",
                lead_status: mapping?.lead_status || "none",
                lead_date: mapping?.lead_date || "none",
            },
        };
        let response = await sendAllSourceUpdate(data, ftpMappingId, "default");
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            setShowFtpMapping(false);
            setMapping({
                lead_id: "",
                lead_status: "",
                lead_date: "",
            });
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
    };

    return (
        <div>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center">
                    <ClipLoader color="#729abf " size={50} />
                </div>
            ) : (
                <Form>
                    {hasNoMapping && (
                        <MappingEmptyState
                            title={
                                language?.source_modal?.no_mapping_title ??
                                "No mapping configured"
                            }
                            subtitle={
                                language?.source_modal?.no_mapping_subtitle ??
                                "This source has no field mappings yet. Use the form below to set one up."
                            }
                        />
                    )}
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInput1"
                    >
                        <div className="row d-flex justify-content-between my-3">
                            <div className="col-5">
                                <Form.Control
                                    placeholder=" Lead ID"
                                    className="leadgenInput"
                                    disabled
                                    style={{ backgroundColor: "#efefef" }}
                                />
                            </div>
                            <div className="col-2 d-flex justify-content-center align-items-center">
                                <FontAwesomeIcon icon={faPlusCircle} />
                            </div>
                            <div className="col-5">
                                <Form.Control
                                    className="lead_id"
                                    value={mapping.lead_id}
                                    onChange={(e) =>
                                        handleSourceFieldChange(
                                            e.target.value,
                                            "lead_id",
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between my-3">
                            <div className="col-5">
                                <Form.Control
                                    placeholder=" Lead Status"
                                    className="leadgenInput"
                                    disabled
                                    style={{ backgroundColor: "#efefef" }}
                                />
                            </div>
                            <div className="col-2 d-flex justify-content-center align-items-center">
                                <FontAwesomeIcon icon={faPlusCircle} />
                            </div>
                            <div className="col-5">
                                <Form.Control
                                    className="lead_status"
                                    value={mapping.lead_status}
                                    onChange={(e) =>
                                        handleSourceFieldChange(
                                            e.target.value,
                                            "lead_status",
                                        )
                                    }
                                />
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between my-3">
                            <div className="col-5">
                                <Form.Control
                                    placeholder=" Date"
                                    className="leadgenInput"
                                    disabled
                                    style={{ backgroundColor: "#efefef" }}
                                />
                            </div>
                            <div className="col-2 d-flex justify-content-center align-items-center">
                                <FontAwesomeIcon icon={faPlusCircle} />
                            </div>
                            <div className="col-5">
                                <Form.Control
                                    className="lead_date"
                                    value={mapping.lead_date}
                                    onChange={(e) =>
                                        handleSourceFieldChange(
                                            e.target.value,
                                            "lead_date",
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </Form.Group>
                    <Modal.Footer className="justify-content-between p-0 pt-3">
                        <Button
                            color="error"
                            variant="contained"
                            onClick={closeModal}
                        >
                            {language?.buttons?.close ?? "Close"}
                        </Button>
                        <Button
                            className="source-button"
                            onClick={sendMappingData}
                        >
                            Update
                        </Button>
                    </Modal.Footer>
                </Form>
            )}
        </div>
    );
};

export default AllSelectSourceEditMappings;
